import { Injectable } from '@angular/core';
import { ValidationResult } from 'src/app/shared/domain/validation-result.entity';
import { IVerifyInvoice, IInvoiceItem } from 'src/app/shared/domain/invoice.entity';
import { IRequestId } from 'src/app/shared/domain/id.entity';
import { ICryptoRequest } from 'src/app/shared/domain/requests/crypto.request.entity';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class InvoiceService {

  private readonly baseUrl = `${environment.apiBaseUrl}invoice`;
  constructor(private httpClient: HttpClient) {
  }

  getAttachedInvoices(body: IRequestId): Observable<IClaimedInvoice[]> {
    return this.httpClient.post<IClaimedInvoice[]>(this.baseUrl + '/attached', body);
  }

  getInvoice(body: IInvoiceRequest): Observable<ValidationResult<IVerifyInvoice>> {
    return this.httpClient.post<ValidationResult<IVerifyInvoice>>(this.baseUrl + '/verify', body);
  }

  getInvoicesItems(body: IInvoiceItemsRequest): Observable<IInvoiceItem[]> {
    return this.httpClient.post<IInvoiceItem[]>(this.baseUrl + '/items', body);
  }

  pullInvoice(body: IInvoiceRequest): Observable<any> {
    return this.httpClient.post<ValidationResult<any>>(this.baseUrl + '/pull', body);
  }
}

export interface IInvoiceItemsRequest extends ICryptoRequest {
  id: number;
  ticketIds: string;
  shopId?: number;
}

export interface IClaimedInvoice {
  invoiceNum: string;
  ticketId: number;
}

export interface IInvoiceRequest extends ICryptoRequest {
  id?: number;
  invoice?: string;
  shipVendorId?: number;
  isManual?: boolean;
  shopId?: number;
}
